
const Blogs = () => {
  return (
    <div className='text-4xl  h-screen flex justify-center items-center'>
      <p>Coming Soon...</p>
    </div>
  );
}

export default Blogs